import React from 'react';
import { Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import SubmitButton from 'Shared/form/SubmitButton';

const ActionButtons = ({ onReset, onCancel, onSave }) => {
    const { dirty, isSubmitting, values } = useFormikContext();
    const isResetDisabled = !dirty || isSubmitting;

    return (
        <Col md={10}>
            <FormButtonGroup style={{ marginBottom: '1.25rem' }}>
                <Button variant="outline-secondary" disabled={isResetDisabled} onClick={onReset}>
                    Reset
                </Button>
                <Button variant="outline-secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <SubmitButton onClick={onSave} disabled={!values.assignedTherapeuticCategories.length}>
                    Save
                </SubmitButton>
            </FormButtonGroup>
        </Col>
    );
};

ActionButtons.propTypes = {
    onReset: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export default ActionButtons;
